/**
 * @Author: Varun
 *
 * Combines all the modules into one module. The injected modules can specify their own dependent modules
 */
angular.module('AppCtrl', [
    'ngRoute',
    'App.video.service',
    'jv.Common.Directives.Select2',
    'jv.Common.i18n',
    'jv.Common.Jobvite.Urls',
    'jv.Common.Modal',
    'jv.Common.TemplateLoader',
    'jv.Common.Filters',
    'jv.video.jobseeker.list.controller',
    'jv.video.request.extension.controller'
])
.config(['$locationProvider', function($locationProvider) {
    $locationProvider.hashPrefix('');
}])
.value('modalTemplateUrl', 'modalTemplate.html');
